/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PatientName({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/PatientName"
  
}) {
let appointmentPatientValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'patient',
format: fromFormat.patientName,
})
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 data="appointment.patient"
 format="/Data/format.js patientName"
 text={appointmentPatientValueData}
 color={dtColorsBrandBase}
/>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginRight={dtSpaceXxs}
 text=","
 color="rgba(19,126,197,1)"
/>
{children}
</React.Fragment>)
}